/**
 * Environment variable validation using Zod
 */

import { z } from 'zod'

const envSchema = z.object({
  VITE_AUTH0_DOMAIN: z.string().min(1, 'Auth0 domain is required'),
  VITE_AUTH0_CLIENT_ID: z.string().min(1, 'Auth0 client ID is required'),
  VITE_AUTH0_AUDIENCE: z.string().min(1, 'Auth0 audience is required'),
  VITE_API_BASE_URL: z.string().url().default('http://localhost:8787'),
  VITE_FRONTEND_URL: z.string().url().default('http://localhost:3000'),
  VITE_GOLD_PRICE_API_URL: z
    .string()
    .url()
    .default('https://sjc.com.vn/GoldPrice/Services/PriceService.ashx'),
  VITE_ENV: z.enum(['development', 'production', 'test']).default('development'),
})

type Env = z.infer<typeof envSchema>

/**
 * Validated environment variables
 */
let env: Env

try {
  env = envSchema.parse({
    VITE_AUTH0_DOMAIN: import.meta.env.VITE_AUTH0_DOMAIN,
    VITE_AUTH0_CLIENT_ID: import.meta.env.VITE_AUTH0_CLIENT_ID,
    VITE_AUTH0_AUDIENCE: import.meta.env.VITE_AUTH0_AUDIENCE,
    VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
    VITE_FRONTEND_URL: import.meta.env.VITE_FRONTEND_URL,
    VITE_GOLD_PRICE_API_URL: import.meta.env.VITE_GOLD_PRICE_API_URL,
    VITE_ENV: import.meta.env.VITE_ENV,
  })
} catch (error) {
  if (error instanceof z.ZodError) {
    const missingVars = error.errors.map((e) => e.path.join('.')).join(', ')
    throw new Error(
      `Environment variable validation failed. Missing or invalid: ${missingVars}. Please check your .env file.`
    )
  }
  throw error
}

export default env

